export const SIDEBAR_BADGES_REFRESH_EVENT = "sidebar-badges-refresh";

export const refreshSidebarBadges = () => {
  window.dispatchEvent(new CustomEvent(SIDEBAR_BADGES_REFRESH_EVENT));
};
